import { render, staticRenderFns } from "./AdminChartsSection.vue?vue&type=template&id=e99628b4&scoped=true"
import script from "./AdminChartsSection.vue?vue&type=script&lang=js"
export * from "./AdminChartsSection.vue?vue&type=script&lang=js"
import style0 from "./AdminChartsSection.vue?vue&type=style&index=0&id=e99628b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99628b4",
  null
  
)

export default component.exports